import { ShieldCheck } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

// ── ComplianceDashboardEmptyState — RET-10: the Compliance Dashboard's OWN empty state ──────────────────────────
// Replaces the Enterprise Risk empty state the page borrowed ("Welcome to Enterprise Risk" + risk-response create
// buttons), retired with that dashboard. ⚠ NO call to action (PE/MI): the dashboard still reads the legacy framework
// activation, so a tenant that adopted frameworks in Framework Programs lands here too — a button sending them there
// would loop. The copy states what is true for every tenant until the TC6 rewrite (B-CDASH-READS-LEGACY-ACTIVATION).
export function ComplianceDashboardEmptyState() {
  return (
    <Card data-testid="compliance-dashboard-empty">
      <CardContent className="flex flex-col items-center gap-4 py-12 text-center">
        <ShieldCheck className="h-12 w-12 text-text-secondary" />
        <div>
          <p className="font-semibold text-text-primary">No framework data to show yet.</p>
          <p className="mt-1 text-sm text-text-secondary">
            This dashboard is being rebuilt on Framework Programs and will populate in a later release.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
